import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import '../styles/FacultyDashboard.css'; // Import CSS file

ChartJS.register(ArcElement, Tooltip, Legend, Title);

const FacultyDashboard = () => {
  const [allRows, setAllRows] = useState([]);
  const [eligibilityChartData, setEligibilityChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: []
      }
    ]
  });
  const [departmentChartData, setDepartmentChartData] = useState({
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: []
      }
    ]
  });
  const [showEligible, setShowEligible] = useState(true);
  const [selectedDepartment, setSelectedDepartment] = useState(null);

  useEffect(() => {
    fetch("https://backend-main-4.onrender.com/data")
      .then((response) => response.json())
      .then((rows) => {
        setAllRows(rows);
        calculateChartData(rows);
      });
  }, []);

  const calculateChartData = (rows) => {
    const totalStudents = rows.length;
    const eligibleStudents = rows.filter(row => 
      parseFloat(row[6]) > 60 && 
      parseFloat(row[7]) > 60 && 
      parseFloat(row[8]) > 60
    ).length;

    setEligibilityChartData({
      labels: ["Eligible for Placement", "Not Eligible for Placement"],
      datasets: [
        {
          data: [
            eligibleStudents,
            totalStudents - eligibleStudents
          ],
          backgroundColor: ["#36A2EB", "#FF6384"]
        }
      ]
    });

    const departmentCounts = {};
    rows.forEach(row => {
      if (parseFloat(row[6]) > 60 && parseFloat(row[7]) > 60 && parseFloat(row[8]) > 60) {
        const department = row[5];
        if (departmentCounts[department]) {
          departmentCounts[department]++;
        } else {
          departmentCounts[department] = 1;
        }
      }
    });

    setDepartmentChartData({
      labels: Object.keys(departmentCounts),
      datasets: [
        {
          data: Object.values(departmentCounts),
          backgroundColor: ["#FF6384", "#36A2EB", "#FFCE56", "#4BC0C0", "#9966FF", "#FF9F40"]
        }
      ]
    });
  };

  const renderCategory = (title, filterCondition) => {
    const filteredRows = allRows.filter(filterCondition);
    return (
      <div className="category">
        <h3>{title} ({filteredRows.length})</h3>
        <ul>
          {filteredRows.map((row, index) => (
            <li key={index}>
              <div className="details">
                <strong>{row[1]}</strong>
                <span>Roll Number: {row[0]}</span>
                <span>Department: {row[5]}</span>
                <span>Class: {row[4]}</span>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  };

  const handlePieClick = (elements, chartType) => {
    if (elements.length > 0) {
      const index = elements[0].index;
      if (chartType === 'eligibility') {
        setShowEligible(index === 0);
        setSelectedDepartment(null);
      } else if (chartType === 'department') {
        setSelectedDepartment(departmentChartData.labels[index]);
        setShowEligible(false);
      }
    }
  };

  return (
    <div>
      <div className="container mt-5">
        <h2 className="text-center">Trainer Dashboard</h2>
        <div className="row">
          <div className="pie-chart">
            <Pie 
              data={eligibilityChartData} 
              options={{
                onClick: (event, elements) => handlePieClick(elements, 'eligibility'),
                plugins: {
                  title: {
                    display: true,
                    text: 'Total Student Eligibility'
                  }
                }
              }}
            />
          </div>
          <div className="pie-chart">
            <Pie 
              data={departmentChartData} 
              options={{
                onClick: (event, elements) => handlePieClick(elements, 'department'),
                plugins: {
                  title: {
                    display: true,
                    text: 'Department Distribution of Eligible Students'
                  }
                }
              }}
            />
          </div>
          <div className="category">
            {selectedDepartment
              ? renderCategory(`Eligible Students from ${selectedDepartment}`, row => 
                  parseFloat(row[6]) > 60 && 
                  parseFloat(row[7]) > 60 && 
                  parseFloat(row[8]) > 60 && 
                  row[5] === selectedDepartment
                )
              : showEligible
              ? renderCategory("Eligible for Placement", row => 
                  parseFloat(row[6]) > 60 && 
                  parseFloat(row[7]) > 60 && 
                  parseFloat(row[8]) > 60
                )
              : renderCategory("Not Eligible for Placement", row => 
                  parseFloat(row[6]) <= 60 || 
                  parseFloat(row[7]) <= 60 || 
                  parseFloat(row[8]) <= 60
                )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FacultyDashboard;
